export default "/images/primary-theme.png?bb96e2cc68c919651898df7d854fb0b2";